import {
  AudienceEventConditionInput,
  AudienceEventDateOneOfConditionInput,
  AudienceTargetingAttributesInput,
} from '@occc/graphql';
import { getExcludeThresholdAndOperator } from './getExcludeThresholdAndOperator';
import { QualifiedEventsFormValues, QualifiedEventType, TimePeriod } from '../../types';

export const convertQualifiedEventsFormValuesToTargetingAttributeInput = (
  eventsFormValues: QualifiedEventsFormValues[],
): Pick<AudienceTargetingAttributesInput, 'inAllEventTargetingAttribute'> => {
  const eventInputs = eventsFormValues
    .map((values) => {
      const { timePeriodType, timeWindow, fixedWindow } = values;
      const audienceEventDateCondition: AudienceEventDateOneOfConditionInput = {
        timeWindow: timePeriodType === TimePeriod.RollingWindow ? { timeWindow } : undefined,
        fixedDateRange:
          timePeriodType === TimePeriod.FixedWindow
            ? {
                startDate: fixedWindow.startDate.toISOString(),
                endDate: fixedWindow.endDate.toISOString(),
              }
            : undefined,
        relativeMonthBack:
          timePeriodType === TimePeriod.PreviousMonth ? { relativeMonthsBack: 1 } : undefined,
      };
      if (values.event === QualifiedEventType.FulfilledLoyaltyEvent && values.loyaltyEvent.id) {
        const { times, loyaltyEvent, timesOperator } = values;

        const eventInput: AudienceEventConditionInput = {
          times,
          operator: timesOperator,
          loyaltyEventUuid: loyaltyEvent.id,
          audienceEventDateCondition,
        };

        return eventInput;
      }

      if (values.event === QualifiedEventType.MadePurchase && values.productGroups.length) {
        const {
          times,
          productGroups,
          countProductsBy,
          locations,
          locationGroups,
          threshold,
          operator,
          timesOperator,
        } = values;

        const { excludeThreshold, operator: purchaseConditionOperator } =
          getExcludeThresholdAndOperator(operator);

        const eventInput: AudienceEventConditionInput = {
          times,
          operator: timesOperator,
          purchaseCondition: {
            productGroupUuids: productGroups.map((group) => group.id),
            purchasedLocationUuids: locations?.map((location) => location.uuid),
            purchasedLocationGroupUuids: locationGroups?.map((locationGroup) => locationGroup.uuid),
            countProductsBy,
            threshold,
            excludeThreshold,
            operator: purchaseConditionOperator,
          },
          audienceEventDateCondition,
        };

        return eventInput;
      }

      return null;
    })
    .filter((input): input is AudienceEventConditionInput => !!input);

  return {
    inAllEventTargetingAttribute: eventInputs.length
      ? {
          conditions: eventInputs,
        }
      : undefined,
  };
};
